import { Controller } from "stimulus"
const timeout = 1000;
export default class extends Controller {
  static get targets() {
    return ['time'];
  }


  initialize(){
    let time = parseInt(this.data.get('seconds'),10);
    this.showTime(time);
    if(time > 1.0){
      setInterval(this.fixTime(this), timeout);
    }
  }

  fixTime(t){
    return () => {
    let time = parseInt(t.data.get('seconds'),10);
  if(this.showTime(time - 1)){
    this.data.set('seconds', time - 1);
      }
    }
  }

  showTime(time){
    if(time < 1.0){
      this.element.style.visibility = 'hidden';
      return false;
     
    }
    else
    {
      this.element.style.visibility = 'visible';
      let minutes  = Math.floor((time / 60));
      let minute_display = "";
      if( minutes > 0) {

        minute_display = minutes + " minute";

        if(minutes > 1){
          minute_display += "s";
        }

        minute_display += ", ";
      }
      let seconds_after = time % 60;

      let second_display = "";

      if(seconds_after > 0){
        second_display = seconds_after + " seconds"
      }

      this.timeTarget.innerText = minute_display + second_display ;
      return true;
    }
  }

}
